import './accordion';

class tabAccordion {
    constructor() {
        this.initializeAccordion();
        this.popModel();
    }

    initializeAccordion() {
        $('.hs-responsive-tabs').responsiveTabs({
            accordionOn: ['xs', 'sm'],
        });
    }

    popModel() {
        var $linkTrigger = document.querySelectorAll('.js-trigger-tab-modal');

        for (var i = 0; i < $linkTrigger.length; i++) {
            $linkTrigger[i].addEventListener('click', this.popupTrigger, false);
        }
        
    }

    popupTrigger(event) {
        event.preventDefault();
        var elem = $(event.currentTarget)
        if(elem.attr('href')!= '#' && elem.attr('href')!='')
            window.location.href = elem.attr('href');
        const $body = document.querySelector('body');
        var $themeHeader = document.querySelector('.theme-header');
        var $tabModal = document.querySelector('.tab-modal');
        var imgHolder = document.querySelector('.popup-image-holder img');
        imgHolder.src="";
        imgHolder.classList.add('d-none');
        if(this.getAttribute("data-popup-image")!=""){
            if(this.getAttribute("data-popup-type")=='image'){
                imgHolder.classList.remove('d-none');
                imgHolder.src=this.getAttribute("data-popup-image");
                $tabModal.classList.toggle('is-open');
                $tabModal.classList.toggle('is-closed');
                $body.classList.toggle('overflow-hidden');
                $themeHeader.classList.toggle('bg-sand');
            }
            if(this.getAttribute("data-popup-type")=='application'){
                window.open( this.getAttribute("data-popup-image"), "_blank");
            }   
        }
        else
            imgHolder.src="";
        
    }
}

export default tabAccordion;
new tabAccordion();
